import { useCallback } from 'react'
import { useFetchRefactored, useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'

interface CancelRegistrationsResponse {
  success: boolean
  cancelledIds: number[]
  failedIds: number[]
  skippedIds: number[]
  errors: { id: number; error: string }[]
}

export const useCancelRegistrations = () => {
  const organization = useCurrentOrg()
  const createNotification = useCreateApiNotification()

  const [fetch] = useFetchRefactored<CancelRegistrationsResponse>({
    successMessage: 'Registrations cancelled successfully',
    errorMessage: 'Failed to cancel registrations',
    useNewNotification: true,
  })

  return useCallback(
    async (ids: number[]): Promise<CancelRegistrationsResponse> => {
      const result = await fetch({
        method: 'del',
        url: `/organizations/${organization.id}/registrations`,
        config: {
          queryStringParameters: { ids },
        },
      })

      // Show detailed notifications based on results
      if (result.failedIds.length > 0) {
        const errorMessage = `Failed to cancel ${result.failedIds.length} registration(s). ${
          result.errors.length > 0 ? result.errors[0].error : 'Unknown error'
        }`
        createNotification(errorMessage)
      }

      //TODO my instinct is this should be optional behavior, but for now we aren't supporting it on the backend
      // if (result.skippedIds.length > 0) {
      //   const skipMessage = `Skipped ${result.skippedIds.length} registration(s) - events have already passed`
      //   createNotification(skipMessage)
      // }

      return result
    },
    [fetch, organization.id, createNotification],
  )
}
